
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export interface Area    { id:number; storeId:number; description:string; }
export interface Table   { id:number; storeId:number; areaId:number; tableName:string; seatingCapacity:number; }
export interface AreaDTO { storeId:number; name:string }
export interface TableDTO{ storeId:number; areaId:number; tableName:string; seatingCapacity:number; tableDetailsJson:string }

@Injectable({ providedIn:'root' })
export class TableService {
  private base = environment.NEW_BACKEND_URL + 'api/tables';
  constructor(private http: HttpClient){}

  getAreas(storeId:number) {
    return this.http.get<Area[]>(`${this.base}/areas`, { params: new HttpParams().set('storeId',storeId) });
  }
  addArea(dto:AreaDTO) {
    return this.http.post<Area>(`${this.base}/areas`, dto);
  }
  getTables(storeId:number) {
    return this.http.get<Table[]>(this.base, { params: new HttpParams().set('storeId',storeId) });
  }
  addTable(dto:TableDTO) {
    return this.http.post<Table>(this.base, dto);
  }
  deleteTable(id:number) {
    return this.http.delete(`${this.base}/${id}/delete`);
  }
}
